export interface PointThreshold {
	level: number,
	points: number,
	euros: number
}

export const POINT_THRESHOLDS: PointThreshold[] = [
	{
		level: 1,
		points: 250,
		euros: 5
	},
	{
		level: 2,
		points: 500,
		euros: 10
	},
	{
		level: 3,
		points: 750,
		euros: 15
	}
];

export const getCurrentThreshold = (points: number): PointThreshold => {
	const threshold = POINT_THRESHOLDS.find(threshold => threshold.points > points);
	return threshold ? threshold : POINT_THRESHOLDS[2];
};

export const getLevelReached = (points: number): number => {
	const threshold = POINT_THRESHOLDS.filter(threshold => threshold.points <= points).pop();
	return threshold ? threshold.level : 0;
};

